import { TimelineNoteWysiwygInput } from 'domain/shared/core/input';
import { BigFormRow } from 'framework/ui/layout';
import { NoteAttachmentUploaderInput } from 'domain/shared/artifact/input';

type RiskNoteFormProps = {
  label?: string;
};

const RiskNoteForm = ({ label = 'Text' }: RiskNoteFormProps) => {
  return (
    <>
      <BigFormRow>
        <TimelineNoteWysiwygInput artifactsSource="attachmentPaths" source="text" label={label} isRiskService={true} />
      </BigFormRow>
      <BigFormRow>
        <NoteAttachmentUploaderInput label="Attachments" source="attachmentPaths" isRiskService={true} />
      </BigFormRow>
    </>
  );
};

export default RiskNoteForm;
